const CONTAINER_SELECTOR = '.c-musegroup-2022_content';
const SVG_CLASS = 'c-musegroup-2022_lines';
const RESIZE_DEBOUNCE = 200;

export class ConnectedLines {
  static init() {
    this.containers = [...document.querySelectorAll(CONTAINER_SELECTOR)];
    if (this.containers.length === 0) return;

    this.instances = this.containers.map((container) => {
      const pairs = this.findPairs(container);
      if (pairs.length === 0) return null;

      const svg = this.createSVG(container);
      return { container, pairs, svg };
    }).filter(Boolean);

    if (this.instances.length === 0) return;

    this.drawAll();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.drawAll(), RESIZE_DEBOUNCE);
    });
  }

  static findPairs(container) {
    const starts = container.querySelectorAll('[data-line-start]');
    const pairs = [];

    starts.forEach((startEl) => {
      const id = startEl.getAttribute('data-line-start');
      const endEl = container.querySelector(`[data-line-end="${id}"]`);
      if (endEl) {
        pairs.push({ start: startEl, end: endEl });
      }
    });

    return pairs;
  }

  static createSVG(container) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.classList.add(SVG_CLASS);
    container.style.position = 'relative';
    container.appendChild(svg);
    return svg;
  }

  static isVisible(el) {
    return el.offsetParent !== null;
  }

  static drawAll() {
    this.instances.forEach((instance) => this.drawLines(instance));
  }

  static drawLines({ container, pairs, svg }) {
    while (svg.firstChild) {
      svg.removeChild(svg.firstChild);
    }

    if (!this.isVisible(container)) return;

    const containerRect = container.getBoundingClientRect();

    pairs.forEach(({ start, end }) => {
      const startRect = start.getBoundingClientRect();
      const endRect = end.getBoundingClientRect();

      const x1 = startRect.left + startRect.width / 2 - containerRect.left;
      const y1 = startRect.bottom - containerRect.top;

      const x2 = endRect.left + endRect.width / 2 - containerRect.left;
      const y2 = endRect.top - containerRect.top;

      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', x1);
      line.setAttribute('y1', y1);
      line.setAttribute('x2', x2);
      line.setAttribute('y2', y2);
      line.setAttribute('stroke', 'white');
      line.setAttribute('stroke-width', '1');

      svg.appendChild(line);
    });
  }
}
